export default __webpack_public_path__ + "static/media/FlagOfUSA.0be09fa4.svg";